export default "__VITE_ASSET__0a347332__"